import {
    GET_USER,
    GET_QUALIFICATION_CATEGORIES,
    SET_UPDATED_QUAL_INFO,
    SET_UPDATED_PROFILE_INFO,
    SET_SINGLE_PROFILE_VALUE,
    GET_PROFILE,
    GET_DEPARTMENTS,
    GET_AREAS,
    GET_LOGGED_UID,
    GET_ALL_USERS,
    UPDATE_SELECTED_USER_PASSWORD,
    GET_USERTYPES,
    UPLOAD_FILE,
    GET_USER_JOBPACKS,
} from "./types";
import moment from "moment";
import firebase from "firebase/app";
import _ from "lodash";
import { SET_SNACKBAR_STATE } from "../QualificationsManager/types";

export const getUserTypes = () => {
    return dispatch => {
        dispatch({ type: GET_USERTYPES.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_USERTYPES.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/user_types")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_USERTYPES.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_USERTYPES.FAIL });
        }
    };
};

export const getDepartments = () => {
    return dispatch => {
        dispatch({ type: GET_DEPARTMENTS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_DEPARTMENTS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/departments")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_DEPARTMENTS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_DEPARTMENTS.FAIL });
        }
    };
};
export const getAreas = () => {
    return dispatch => {
        dispatch({ type: GET_AREAS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_AREAS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/areas")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_AREAS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_AREAS.FAIL });
        }
    };
};

export const getUser = (uid = false) => {
    return dispatch => {
        dispatch({ type: GET_USER.REQUEST });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/users/${uid}`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_USER.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                } else {
                    dispatch({ type: GET_USER.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_USER.FAIL });
        }
    };
};

export const getLoggedUID = () => {
    return dispatch => {
        dispatch({ type: GET_LOGGED_UID.REQUEST });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    dispatch({
                        type: GET_LOGGED_UID.SUCCESS,
                        payload: user.uid
                    });
                } else {
                    dispatch({ type: GET_LOGGED_UID.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_LOGGED_UID.FAIL });
        }
    };
};
export const getProfile = () => {
    return dispatch => {
        dispatch({ type: GET_PROFILE.REQUEST });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/users/${user.uid}`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_PROFILE.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                } else {
                    dispatch({ type: GET_PROFILE.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_PROFILE.FAIL });
        }
    };
};
export const getAllUsers = () => {
    return dispatch => {
        dispatch({ type: GET_ALL_USERS.REQUEST });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/users/`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_ALL_USERS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                } else {
                    dispatch({ type: GET_ALL_USERS.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_ALL_USERS.FAIL });
        }
    };
};
export const getQualificationCategories = () => {
    return dispatch => {
        dispatch({ type: GET_QUALIFICATION_CATEGORIES.REQUEST });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/collections/qualification_categories`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_QUALIFICATION_CATEGORIES.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                } else {
                    dispatch({ type: GET_QUALIFICATION_CATEGORIES.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_QUALIFICATION_CATEGORIES.FAIL });
        }
    };
};

export const setUpdateQualInfo = (
    id = false,
    uid = false,
    qualInfo = false,
    imgBlob1 = false,
    imgBlob2 = false
) => {
    if(typeof qualInfo.attached_files === "undefined"){
        qualInfo.attached_files = null;
    }
    return dispatch => {
        dispatch({ type: SET_UPDATED_QUAL_INFO.REQUEST });
        if (id && qualInfo && uid) {
            let img1 = _.get(qualInfo, "qualification_img") || "",
                img2 = _.get(qualInfo, "qualification_img_2") || ""
            try {
                firebase.auth().onAuthStateChanged(async user => {
                    if (imgBlob1) {
                        img1 =
                            (await uploadQualificationsImages(
                                imgBlob1,
                                uid,
                                id
                            )) || "";
                    }
                    if (imgBlob2) {
                        img2 =
                            (await uploadQualificationsImages(
                                imgBlob2,
                                id,
                                uid
                            )) || "";
                    }
                    if (user) {
                        firebase
                            .database()
                            .ref(
                                `/users/${uid}/profile/qualifications_per_user`
                            )
                            .child(`${id}`)
                            .update({
                                qualification_img: img1,
                                qualification_img_2: img2,
                                qualification_exp_date:
                                    qualInfo.qualification_exp_date,
                                qualification_reg_num:
                                    qualInfo.qualification_reg_num,
                                qualification_verified:
                                    qualInfo.qualification_verified,
                                attached_files:
                                    qualInfo.attached_files
                            })
                            .then(() =>
                                dispatch({
                                    type: SET_UPDATED_QUAL_INFO.SUCCESS
                                })
                            )
                            .catch(() =>
                                dispatch({ type: SET_UPDATED_QUAL_INFO.FAIL })
                            );
                    } else {
                        dispatch({ type: SET_UPDATED_QUAL_INFO.FAIL });
                    }
                });
            } catch {
                dispatch({ type: SET_UPDATED_QUAL_INFO.FAIL });
            }
        } else {
            dispatch({ type: SET_UPDATED_QUAL_INFO.FAIL });
        }
    };
};
export const uploadQualificationsImages = async (
    imgBlob = false,
    qualificationID = false,
    userUID = false
) => {
    if (imgBlob && qualificationID && userUID) {
        let imgUploadURL = firebase
            .storage()
            .ref(`users/${userUID}/qualification_imgs/${qualificationID}`)
            .put(imgBlob)
            .then(async snapshot => {
                try {
                    const url = await snapshot.ref.getDownloadURL();
                    return url;
                } catch (e) {
                    return false;
                }
            })
            .catch(() => {
                return false;
            });
        return imgUploadURL;
    } else {
        return false;
    }
};
export const submitUpdatedProfile = (profile = false, profileBlob = false) => {
    return dispatch => {
        dispatch({ type: SET_UPDATED_PROFILE_INFO.REQUEST });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    if ((profile && profileBlob) !== false) {
                        firebase
                            .storage()
                            .ref(`/users/${profile.uid}/profile/`)
                            .put(profileBlob)
                            .then(snapshot => {
                                snapshot.ref
                                    .getDownloadURL()
                                    .then(url => {
                                        profile.profile_image_url = url;
                                        firebase
                                            .database()
                                            .ref(`/users/${profile.uid}`)
                                            .update({ profile })
                                            .then(() => {
                                                dispatch({
                                                    type:
                                                        SET_UPDATED_PROFILE_INFO.SUCCESS
                                                });
                                            });
                                    })
                                    .catch(() =>
                                        dispatch({
                                            type: SET_UPDATED_PROFILE_INFO.FAIL
                                        })
                                    );
                            });
                            firebase    
                                .database()
                                .ref(`/collections/user_meta_data/${profile.uid}`)
                                .update({areas:profile.areas||[],departments:profile.departments||[]})
                    } else if (profile) {
                        firebase
                            .database()
                            .ref(`/users/${profile.uid}`)
                            .update({ profile })
                            .then(() =>
                                dispatch({
                                    type: SET_UPDATED_PROFILE_INFO.SUCCESS
                                })
                            )
                            .catch(() =>
                                dispatch({
                                    type: SET_UPDATED_PROFILE_INFO.FAIL
                                })
                            );
                        firebase    
                                .database()
                                .ref(`/collections/user_meta_data/${profile.uid}`)
                                .update({areas:profile.areas||[],departments:profile.departments||[]})
                    } else {
                        dispatch({ type: SET_UPDATED_PROFILE_INFO.FAIL });
                    }
                } else {
                    dispatch({ type: SET_UPDATED_PROFILE_INFO.FAIL });
                }
            });
        } catch {
            dispatch({ type: SET_UPDATED_PROFILE_INFO.FAI });
        }
    };
};
export const setSnackBarState = (state = false) => {
    return dispatch => {
        dispatch({ type: SET_SNACKBAR_STATE, payload: state });
    };
};
export const setUpdateInfo = (uid = false, value = false) => {
    return dispatch => {
        dispatch({ type: SET_SINGLE_PROFILE_VALUE.REQUEST });

        if (uid && value) {
            try {
                firebase.auth().onAuthStateChanged(user => {
                    if (user) {
                        firebase
                            .database()
                            .ref(`/users/${uid}/`)
                            .update({ profile:value });
                        dispatch({ type: SET_SINGLE_PROFILE_VALUE.SUCCESS });
                    } else {
                        dispatch({ type: SET_SINGLE_PROFILE_VALUE.FAIL });
                    }
                });
            } catch {
                dispatch({ type: SET_SINGLE_PROFILE_VALUE.FAIL });
            }
        } else {
            dispatch({ type: SET_SINGLE_PROFILE_VALUE.FAIL });
        }
    };
};
export const updateSelectedUserPassword = (
    uid = false,
    password = false,
    setUpdatingProgress
) => {
    return dispatch => {
        dispatch({ type: UPDATE_SELECTED_USER_PASSWORD.REQUEST });
        setUpdatingProgress(true);
        if (uid && password) {
            let updatePasswordCloudFunction = firebase
                .functions()
                .httpsCallable("changeSelectedUserPassword");

            updatePasswordCloudFunction({ uid, password })
                .then(() => {
                    setUpdatingProgress(false);
                    dispatch({ type: UPDATE_SELECTED_USER_PASSWORD.SUCCESS });
                })
                .catch(() => {
                    setUpdatingProgress(false);
                    dispatch({ type: UPDATE_SELECTED_USER_PASSWORD.FAIL });
                });
        } else {
            dispatch({ type: UPDATE_SELECTED_USER_PASSWORD.FAIL });
        }
    };
};

export const generateQualAlerts = (alerts = false) => {
    return dispatch => {
        // dispatch({type: GENERATE_ALERTS.REQUEST})
        if (alerts) {
            Object.keys(alerts).map(e => {
                let uid = alerts[e].uid;
                let details = alerts[e].details;
                firebase
                    .database()
                    .ref(`/subjects/alerts/qualification_expiry/${uid}`)
                    .update(details);
                return null;
            });
        }
    };
};

export const uploadFile = (
    file = false,
    file_type = "",
    successCallback,
    newAttachedFile
) => {
    return async dispatch => {
        dispatch({ type: UPLOAD_FILE.REQUEST });
        let newFileID = await getNewFileID();
        let fileExists = await doesFileExist(file.name, file_type);

        try {
            if (!fileExists) {
                let upload = firebase
                    .storage()
                    .ref(`file_manager/qualification_documents`)
                    .child(file.name)
                    .put(file);

                upload.on(
                    "state_changed",
                    snapshot => {
                        let progress =
                            (snapshot.bytesTransferred / snapshot.totalBytes) *
                            100;

                        successCallback({
                            fileExists: false,
                            inProgress: true,
                            finished: false,
                            error: false,
                            progress: progress,
                            msg: "Upload is " + progress + "% done"
                        });
                    },
                    () => {
                        successCallback({
                            fileExists: false,
                            inProgress: false,
                            finished: false,
                            error: true,
                            msg: "Something went wrong with this upload!"
                        });
                        dispatch({ type: UPLOAD_FILE.FAIL });
                    },
                    () => {
                        upload.snapshot.ref.getDownloadURL().then(url => {
                            let newFile = {
                                file_id: newFileID,
                                file_name: file.name,
                                file_size: file.size,
                                file_url: url,
                                file_directory: file_type,
                                date_added: new moment().format(
                                    "DD-MM-YYYY hh:mm:ss"
                                ),
                                file_folder: file_type,
                                file_type: file.type
                            };
                            newAttachedFile({
                                file: file.name,
                                fileURL: url,
                                file_type,
                                file_id: newFileID
                            });
                            firebase
                                .database()
                                .ref(`/subjects/file_manager/qualification_documents/${newFileID}/`)
                                .set(newFile)
                                .then(() => {
                                    dispatch({
                                        type: UPLOAD_FILE.SUCCESS
                                    });
                                    successCallback({
                                        fileExists: false,
                                        inProgress: false,
                                        finished: true,
                                        error: false,
                                        msg: "Success"
                                    });
                                });
                        });
                    }
                );
            } else {
                newAttachedFile(fileExists);
                successCallback({
                    fileExists: true,
                    inProgress: false,
                    finished: false,
                    error: false,
                    msg: "Success"
                });
                dispatch({ type: UPLOAD_FILE.FAIL });
            }
        } catch {
            dispatch({ type: UPLOAD_FILE.FAIL });
        }
    };
};
export const getNewFileID = async () => {
    let files = await getFiles();

    let newFileID;
    if (files) {
        let fileIDs = Object.keys(files).map(fileID => fileID);
        fileIDs = fileIDs.sort().reverse();
        newFileID = (Number(fileIDs[0]) + 1).toString().padStart(6, "0");
        return newFileID;
    } else if (files == null) {
        newFileID = "000001";
        return newFileID;
    }
};
export const doesFileExist = async (name, directory) => {
    let files = await getFiles();

    let flag = false;
    if (files) {
        Object.keys(files).map(index => {
            if (
                files[index].file_name === name &&
                files[index].file_directory === directory
            )
                flag = {
                    file: files[index].file_name,
                    fileURL: files[index].file_url,
                    file_type: files[index].file_type,
                    file_id: files[index].file_id
                };
            return null;
        });
        return flag;
    } else if (files == null) {
        return false;
    }
};
export const getFiles = async () => {
    let files = await firebase
        .database()
        .ref(`subjects/files`)
        .once("value");
    return files.val();
};
export const getUserJobpacks = () => {
    return dispatch => {
        dispatch({ type: GET_USER_JOBPACKS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_USER_JOBPACKS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/subjects/jobpacks/active")
                        .on("value", snapshot => {
                           
                            dispatch({
                                type: GET_USER_JOBPACKS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_USER_JOBPACKS.FAIL });
        }
    };
};